export const NEW_PROPOSAL_ID = 'new' as const;
